// Reusable avatar component — shows photo if available, initials otherwise
// Used everywhere a user's identity is displayed
import { personName } from '../../utils/personName';

interface AvatarProps {
  firstName: string;
  lastName: string;
  photoUrl?: string | null;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizes = {
  xs: 'w-6 h-6 text-xs',
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-16 h-16 text-lg',
  xl: 'w-24 h-24 text-2xl',
};

export default function Avatar({ firstName, lastName, photoUrl, size = 'sm', className = '' }: AvatarProps) {
  const sizeClass = sizes[size];
  // The initials keep the order first name, last name (#479: the operator
  // kept them as they are); the alt text is the name, "Last First".
  const initials = `${firstName?.[0] ?? ''}${lastName?.[0] ?? ''}`.toUpperCase();

  if (photoUrl) {
    return (
      <img
        src={photoUrl}
        alt={personName(firstName, lastName)}
        referrerPolicy="no-referrer"
        className={`${sizeClass} rounded-full object-cover shrink-0 ${className}`}
      />
    );
  }

  return (
    <div className={`${sizeClass} rounded-full bg-gray-900 text-white flex items-center justify-center font-bold shrink-0 ${className}`}>
      {initials}
    </div>
  );
}
